var map = {
	"./ion-action-sheet.entry.js": [
		333,
		5
	],
	"./ion-alert.entry.js": [
		334,
		6
	],
	"./ion-app_8.entry.js": [
		335,
		7
	],
	"./ion-avatar_3.entry.js": [
		336,
		18
	],
	"./ion-back-button.entry.js": [
		337,
		19
	],
	"./ion-backdrop.entry.js": [
		338,
		43
	],
	"./ion-button_2.entry.js": [
		339,
		20
	],
	"./ion-card_5.entry.js": [
		340,
		21
	],
	"./ion-checkbox.entry.js": [
		341,
		22
	],
	"./ion-chip.entry.js": [
		342,
		23
	],
	"./ion-col_3.entry.js": [
		343,
		44
	],
	"./ion-datetime_3.entry.js": [
		344,
		10
	],
	"./ion-fab_3.entry.js": [
		345,
		24
	],
	"./ion-img.entry.js": [
		346,
		45
	],
	"./ion-infinite-scroll_2.entry.js": [
		347,
		46
	],
	"./ion-input.entry.js": [
		348,
		25
	],
	"./ion-item-option_3.entry.js": [
		349,
		26
	],
	"./ion-item_8.entry.js": [
		350,
		27
	],
	"./ion-loading.entry.js": [
		351,
		28
	],
	"./ion-menu_3.entry.js": [
		352,
		29
	],
	"./ion-modal.entry.js": [
		353,
		8
	],
	"./ion-nav_2.entry.js": [
		354,
		15
	],
	"./ion-popover.entry.js": [
		355,
		9
	],
	"./ion-progress-bar.entry.js": [
		356,
		30
	],
	"./ion-radio_2.entry.js": [
		357,
		31
	],
	"./ion-range.entry.js": [
		358,
		32
	],
	"./ion-refresher_2.entry.js": [
		359,
		11
	],
	"./ion-reorder_2.entry.js": [
		360,
		17
	],
	"./ion-ripple-effect.entry.js": [
		361,
		47
	],
	"./ion-route_4.entry.js": [
		362,
		33
	],
	"./ion-searchbar.entry.js": [
		363,
		34
	],
	"./ion-segment_2.entry.js": [
		364,
		35
	],
	"./ion-select_3.entry.js": [
		365,
		36
	],
	"./ion-slide_2.entry.js": [
		366,
		48
	],
	"./ion-spinner.entry.js": [
		367,
		13
	],
	"./ion-split-pane.entry.js": [
		368,
		49
	],
	"./ion-tab-bar_2.entry.js": [
		369,
		37
	],
	"./ion-tab_2.entry.js": [
		370,
		16
	],
	"./ion-text.entry.js": [
		371,
		38
	],
	"./ion-textarea.entry.js": [
		372,
		39
	],
	"./ion-toast.entry.js": [
		373,
		40
	],
	"./ion-toggle.entry.js": [
		374,
		12
	],
	"./ion-virtual-scroll.entry.js": [
		375,
		50
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 184;
module.exports = webpackAsyncContext;